import { toast } from 'react-toastify';
import CopySuccess from "../components/uiComponents/Toasts/CopySuccess";
import React, { useEffect, useState} from "react";

export const copyText = (text: string, message: string) => {       
    toast.dismiss();
    toast(<CopySuccess message={message}/>, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1000,
        theme: 'dark',
            icon: false,
        closeButton: false,            
    });

    
    if ((document as any).queryCommandSupported && (document as any).queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return (document as any).execCommand("copy");  // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
}
